module.exports = __webpack_public_path__ + "img-01.jpg?156cd49407f7a73916cd1729990f0e3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-01.jpg
// module id = 11
// module chunks = 0